import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getPOPDFCustomFieldDisplay } from '../business-logic/use-cases/getPOPDFCustomFieldDisplay'

const base = ['po-pdf-custom-field-display']

// Use-Case-backed config: joins the active PO + order-item custom fields
// with the po-pdf-custom-fields-hidden preference map.
export const poPdfCustomFieldDisplayQueryConfig = {
  display: () => ({
    queryKey: buildQueryKey(base),
    queryFn: () => getPOPDFCustomFieldDisplay(),
  }),
}
